const nf = (min, max) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: min, maximumFractionDigits: max });

const num = (v) => (v === null || v === undefined || v === "" || Number.isNaN(Number(v)) ? null : Number(v));

// Valor financeiro: $1,234.56 (apresentação apenas — precisão real fica na API/DB)
export const formatCurrency = (v, currency = "USD") => {
  const n = num(v);
  if (n === null) return "—";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(n);
};

// P/L com sinal explícito: +$2,040.68 / -$350.26
export const formatSignedCurrency = (v, currency = "USD") => {
  const n = num(v);
  if (n === null) return "—";
  return `${n >= 0 ? "+" : "-"}${formatCurrency(Math.abs(n), currency)}`;
};

// Preço de mercado: 70,308.40 · 1.0854 · 0.00004512
export const formatPrice = (v) => {
  const n = num(v);
  if (n === null) return "—";
  const abs = Math.abs(n);
  if (abs === 0) return "0.00";
  if (abs < 0.001) return nf(2, 8).format(n);
  if (abs < 1) return nf(2, 6).format(n);
  if (abs < 1000) return nf(2, 4).format(n);
  return nf(2, 2).format(n);
};

// Volume/quantidade: mantém a precisão do ativo, sem zeros à direita
export const formatQuantity = (v) => {
  const n = num(v);
  if (n === null) return "—";
  return nf(0, 8).format(n);
};

export const formatPercent = (v, digits = 2) => {
  const n = num(v);
  if (n === null) return "—";
  return `${nf(digits, digits).format(n)}%`;
};

export const fmtMoney = (v, currency = "USD") => formatCurrency(v, currency);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("pt-PT", { dateStyle: "short", timeStyle: "short" }).format(
      new Date(iso)
    );
  } catch {
    return "—";
  }
};
